import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { fetchCutOffDate } from '../services/api';
import { cutoffAtom } from '../atoms/cutoffAtom';

/**
 * Custom hook to read the cutoff state.
 * Returns the cutoff or null if not loaded/error.
 */
export const useCutoffState = () => {
  const cutoffData = useAtomValue(cutoffAtom);
  return cutoffData;
};

/**
 * Custom hook to provide actions related to orders.
 * Currently provides a function to refetch orders.
 */
export const useCutoffActions = () => {
  const setCutoff = useSetAtom(cutoffAtom);

  // Function to trigger a refetch of the cutoff
  const getCutoff = useCallback(
    async (shipTo: string) => {
      try {
        const response = await fetchCutOffDate(shipTo);
        setCutoff(response);
      } catch (error) {
        console.error('[useCutoff] Failed to fetch cutoff:', error);
        // Clear data or set an error state on failure
        setCutoff(null);
      }
    },
    [setCutoff]
  );

  return {
    getCutoff,
    setCutoff,
  };
};
